import "./App.css";

import config from "./config";
import firebase from "firebase/app";

import { BrowserRouter as Router, Route } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import Home from "./components/Home/Home";
import theme from "./theme";
import { CssBaseline } from "@material-ui/core";
import Dashboard from "./components/Dashboard/Dashboard";
import Callback from "./components/Callback";
import {Switch} from "react-router";

if (!firebase.apps.length) {
	firebase.initializeApp(config);
}else {
	firebase.app(); // if already initialized, use that one
}

try {
    global.currentUser = localStorage.getItem("music-by-vote-user")
        ? JSON.parse(localStorage.getItem("music-by-vote-user"))
        : {
            username: "",
            room_code: "",
            role: "guest",
        };
}
catch(err) {
    localStorage.delete("music-by-vote-user");
    global.currentUser = {
        username: "",
        room_code: "",
        role: "guest",
    };
}


let isProd = true;
global.API_URL = (isProd) ? "https://us-central1-music-by-vote.cloudfunctions.net/api" :
    "http://localhost:5001/music-by-vote/us-central1/api";

function App() {
  return (
    <div className="App">
        <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router >
			<Switch>
				<Route path="/dashboard">
					<Dashboard />
				</Route>
				<Route path="/callback">
					<Callback />
				</Route>
				<Route exact path="/:room?">
					<Home />
				</Route>
			</Switch>
		</Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
